<template>
  <div class='frequent_questions-container'>
    <div class="bold_title">Поширені питання</div>
    <div class="question_blockWrapper">
      <div
        v-for="category in categories"
        :key="category.id"
        class="faq-category"
      >
        <div class="question_block_container">
          <h2>{{ category.title }}</h2>
          <div
            v-for="q in questions.filter(q => q.category_id === category.id)"
            :key="q.id"
          >
            <div
              class="question_block"
              @click="showDropDown = showDropDown === q.id ? null : q.id"
            >
              <div class="icon_wrapper">
                <div class="closeIcon" :class="{ rotated: showDropDown === q.id }">＋</div>
              </div>
              <div class="question_text">
                <p>{{ q.q_text }}</p>
              </div>
            </div>
            <transition name="fade">
              <div class="answer"
                   v-if="showDropDown === q.id"
                   v-html="q.q_answer"
              ></div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'FrequentlyQuestions',
  components: {},
  methods: {},
  data() {
    return {
      showDropDown: null,
      categories: [
        { id: 1, title: 'Оформлення кредиту' },
        { id: 2, title: 'Робота з особистим кабінетом і обліковими даними' },
        { id: 3, title: 'Перевірка стану кредиту' },
        { id: 4, title: 'Погашення кредиту' },
        { id: 5, title: 'Прострочка та проблеми з оплатою' },
        { id: 6, title: 'Помилки та питання платежів' },
        { id: 7, title: 'Закриття кредиту та документи' }
      ],
      questions: [
        {
          id: 'faq-001',
          q_text: 'Як пройти ідентифікацію через систему BankID при оформленні кредиту?',
          category_id: 1,
          q_answer: '<strong>Ідентифікація через систему BankID НБУ</strong> - це обов\'язковий етап для підтвердження ваших даних під час розгляду заявки на кредит. Процес простий і займає кілька хвилин:<br> ' +
              '<strong>1. Отримайте посилання:</strong></br>' +
              '<ul><li>Після надсилання заявки ви отримаєте SMS або повідомлення у месенджері з посиланням для проходження ідентифікації</li></ul>' +
              '<strong>2. Перейдіть до ідентифікації:</strong>' +
              '<ul>' +
              '<li>Натисніть на кнопку з логотипом BankID НБУ</li>'+
              '<li>Послуга є безкоштовною</li>'+
              '</ul>'+
              '<strong>3. Оберіть свій банк:</strong>.' +
              '<ul>' +
              '<li>У новому вікні виберіть банк, у якому маєте рахунок.</li>' +
              '<li>Пройдіть автентифікацію на сторінці банку або через мобільний застосунок.</li>' +
              '</ul>'+
              '<strong>4.	Надайте згоду на передачу даних:</strong>'+
              '<ul>' +
              '<li>Перевірте свої дані.</li>' +
              '<li>Підтвердіть згоду на передачу інформації для завершення ідентифікації</li>' +
              '</ul>'+
              '<strong>5. Отримайте рішення</strong>'+
              '<ul>' +
              '<li>Після успішної ідентифікації система автоматично поверне вас на сторінку результату заявки.</li>' +
              '<li>Ви побачите рішення щодо вашого кредиту (приклад позитивного рішення буде відображено на екрані).</li>' +
              '</ul>'+
              '<strong>⚡ Важливо: BankID — це безпечно, швидко і допомагає уникнути необхідності особистої присутності.</strong>>',
        },
        {
          id: 'faq-002',
          q_text: 'Що робити, якщо не приходить код підтвердження під час підписання документів при оформленні заявки?',
          category_id: 1,
          q_answer:
            '<strong>Якщо ви не отримали код підтвердження для підписання документів, виконайте наступні кроки:</strong><br><br>' +
            '<strong>1. Перевірте номер телефону, на який має прийти код:</strong><br>' +
            '<ul><li>Номер має збігатися з тим, який ви вказували під час оформлення заявки.</li>' +
            '<li>Якщо номер неправильний — поверніться на попередній крок і виправте його.</li></ul>' +
            '<strong>2. Перевірте повідомлення у Viber:</strong><br>' +
            '<ul><li>Код може бути надісланий через бізнес-чати Viber.</li>' +
            '<li>Якщо в Viber коду немає — перевірте SMS.</li></ul>' +
            '<strong>3. Дочекайтеся коду:</strong><br>' +
            '<ul><li>Час очікування може становити до 5 хвилин.</li>' +
            '<li><span style="color:red">❗ Не натискайте повторно кнопку відправки коду — це може спричинити затримку або помилку в системі.</span></li></ul>' +
            '<strong>4. Перезавантажте телефон та спробуйте ще раз:</strong><br>' +
            '<ul><li>Якщо коду немає через 5 хвилин, перезавантажте пристрій і повторіть спробу.</li></ul>' +
            '<strong>5. Якщо проблема не вирішилася:</strong><br>' +
            '<ul><li>Зверніться до служби підтримки: <strong><a href="tel:+380445936633">044-593-66-33</a></strong> для оперативної допомоги.</li></ul>',
        },
        {
          id: 'faq-003',
          q_text: 'Як увійти до особистого кабінету Sfactor?',
          category_id: 2,
          q_answer:
            'Щоб увійти в особистий кабінет, виконайте кілька простих кроків:<br><br>' +
            '<strong>Крок 1. Перехід на сайт</strong><br>' +
            '<ul>' +
            '<li>Зайдіть на сайт компанії: <strong><a href="https://sfactor.com.ua">https://sfactor.com.ua</a></strong></li>' +
            '<li>Натисніть кнопку «Особистий кабінет» у правому верхньому куті.</li>' +
            '<li>Вас буде автоматично перенаправлено на сторінку авторизації: <strong><a href="https://auth.sfactor.com.ua">https://auth.sfactor.com.ua</a></strong></li>' +
            '</ul>' +
            '<strong>Крок 2. Введіть номер телефону</strong><br>' +
            '<ul>' +
            '<li>Введіть номер телефону, який ви вказували при оформленні кредиту.</li>' +
            '<li>Натисніть кнопку «Продовжити».</li>' +
            '<li>Якщо це перший вхід, система додатково попросить ввести ваш ІПН.</li>' +
            '</ul>' +
            '<span style="color:red">❗ Вхід можливий тільки за номером телефону, вказаним у договорі. Інші номери не підтримуються.</span><br>' +
            '<strong>Крок 3. Отримайте код підтвердження</strong><br>' +
            '<ul>' +
            '<li>Код підтвердження буде надіслано через SMS або у Viber (перевірте вкладку «Бізнес-чати»).</li>' +
            '<li>Час очікування повідомлення — до 5 хвилин.</li>' +
            '<li><span style="color:red">❗ Не натискайте повторно кнопку «Продовжити», поки не отримаєте код — це може спричинити помилку верифікації.</span></li>' +
            '</ul>' +
            '<strong>Крок 4. Введіть код підтвердження</strong><br>' +
            '<ul>' +
            '<li>Введіть отриманий код у відповідне поле.</li>' +
            '<li>Після успішної перевірки натисніть «Продовжити» і отримайте доступ до особистого кабінету.</li>' +
            '</ul>' +
            '<strong>Крок 5. Якщо виникають питання</strong><br>' +
            '<ul>' +
            '<li>При складнощах звертайтеся до служби підтримки: <strong><a href="tel:+380445936633">044-593-66-33</a></strong></li>' +
            '<li><span style="color:red">! Якщо змінився номер телефону — змінити його можна тільки через звернення до підтримки.</span></li>' +
            '</ul>',
        },
        {
          id: 'faq-004',
          q_text: 'Що робити, якщо не приходить код підтвердження?',
          category_id: 2,
          q_answer:
              'Якщо ви не отримали код підтвердження, виконайте наступні кроки:<br/>'+
              '<br><strong>Перевірте номер телефону, на який має прийти код:</strong>' +
              '<br>- Номер має збігатися з тим, який ви вказували під час оформлення заявки.' +
              '<br>- Якщо номер неправильний — поверніться на попередній крок і виправте його.' +
              '<br><br><strong>Перевірте повідомлення у Viber:</strong>' +
              '<br>- Код може бути надісланий через бізнес-чати Viber.' +
              '<br>- Якщо в Viber коду немає — перевірте SMS.' +
              '<br><br><strong>Дочекайтеся коду:</strong>' +
              '<br>- Час очікування може становити до 5 хвилин.' +
              '<br><span style="color: red;">❗ Не натискайте повторно кнопку відправки коду — це може спричинити затримку або помилку в системі.</span>' +
              '<br><br><strong>Перезавантажте телефон та спробуйте ще раз:</strong>' +
              '<br>- Якщо коду немає через 5 хвилин, перезавантажте пристрій і повторіть спробу.' +
              '<br><br><strong>Якщо проблема не вирішилася:</strong>' +
              '<br>- Зверніться до служби підтримки: <strong><a href="tel:+380445936633">044-593-66-33</a></strong> для оперативної допомоги.'
        },
        {
          id: 'faq-005',
          q_text: 'Як змінити номер телефону в особистий кабінет?',
          category_id: 2,
          q_answer:
              'Зателефонуйте в службу підтримки: <strong><a href="tel:+380445936633">044-593-66-33</a></strong>.<br><br>' +
              '<strong>Робочий час:</strong> щоденно з 9:00 до 19:30.<br><br>' +
              'Для зміни номера підготуйте:<br>' +
              '<ul>' +
              '<li>Ваш ПІБ;</li>' +
              '<li>Номер договору;</li>' +
              '<li>Документ, що підтверджує особу (може знадобитися для верифікації).</li>' +
              '</ul>' +
              '<span style="color:red">⚡ Зміна номера проводиться тільки телефоном — для вашої безпеки.</span>',
        },
        {
          id: 'faq-006',
          q_text: 'Як перевірити стан свого кредитного договору?',
          category_id: 3,
          q_answer:
            'В особистому кабінеті <strong><a href="https://auth.sfactor.com.ua/">https://auth.sfactor.com.ua/</a></strong> ви можете переглянути:<br>' +
            '<ul>' +
            '<li>Стан вашого кредитного договору (активний, прострочений, закритий);</li>' +
            '<li>Актуальний залишок до сплати;</li>' +
            '<li>Історію внесених платежів;</li>' +
            '<li>Графік майбутніх платежів;</li>' +
            '<li>Можливість оплатити кредит онлайн.</li>' +
            '</ul>' +
            '<span style="color:red">⚡ Особистий кабінет — це найшвидший спосіб контролювати свій договір без дзвінків у підтримку.</span> Якщо потрібна допомога, звертайтеся за номером: <strong><a href="tel:+380445936633">044-593-66-33</a></strong>.',
        },
        {
          id: 'faq-007',
          q_text: 'До якого числа потрібно сплачувати кредит?',
          category_id: 3,
          q_answer:
              'Дата кожного платежу вказана в графіку платежів вашого кредитного договору.<br><br>' +
              'Переглянути графік можна:<br>' +
              '<ul>' +
              '<li>У кредитному договорі;</li>' +
              '<li>В особистому кабінеті у розділі «Графік платежів»;</li>' +
              '</ul>' +
              '<strong>Рекомендація:</strong><br>' +
              'Сплачуйте платіж щонайменше за 5 днів до зазначеної дати — це допоможе уникнути прострочок через можливі затримки зарахування коштів банками або платіжними сервісами.<br><br>' +
              '<span style="color:red">⚡ Пам’ятайте: датою платежу вважається дата фактичного надходження коштів на рахунок компанії.</span>',
        },
        {
          id: 'faq-008',
          q_text: 'Як і через які сервіси можна погасити кредит?',
          category_id: 4,
          q_answer:
              'Ви можете сплатити кредит або мінімальний платіж за графіком такими способами:<br><br>' +
              '<strong>1. Через особистий кабінет Sfactor:</strong><br>' +
              '<ul>' +
              '<li>Оплата карткою будь-якого українського банку або через Apple Pay / Google Pay;</li>' +
              '<li>Зарахування — протягом до 3 годин;</li>' +
              '<li><a href="https://auth.sfactor.com.ua">https://auth.sfactor.com.ua</a></li>' +
              '</ul>' +
              '<strong>2. Через ПриватБанк:</strong><br>' +
              '<ul>' +
              '<li>У терміналах (розділ «Комунальні платежі») або в Приват24 (розділ «Мої платежі»);</li>' +
              '<li>Код пошуку: <strong>35310044 (ТОВ «Сучасний Факторинг»)</strong>;</li>' +
              '<li>У призначенні платежу вказуйте номер договору і ІПН;</li>' +
              '</ul>' +
              '<strong>3. Через інші банки:</strong><br>' +
              '<ul>' +
              '<li>У касі або через кабінет банку за реквізитами:</li>' +
              '<li>ПРАВЕКС-БАНК: IBAN <strong>UA463808380000026509799999969</strong>, МФО 380838, ЄДРПОУ 35310044;</li>' +
              '<li>ПУМБ: IBAN <strong>UA893348510000000000265011544</strong>, МФО 334851, ЄДРПОУ 35310044;</li>' +
              '<li>Призначення платежу: "Плата за кредитним договором №______ від (ПІБ)";</li>' +
              '</ul>' +
              '<strong>4. Через термінали City24, Easypay:</strong><br>' +
              '<ul>' +
              '<li>Категорія: «Банківські послуги» → «Банки та фінансові послуги» → компанія «Сучасний Факторинг»;</li>' +
              '<li>Введіть номер договору і сплатіть потрібну суму;</li>' +
              '</ul>' +
              '<strong>5. Через сайт партнера Platon:</strong><br>' +
              '<ul>' +
              '<li>Оплата онлайн через сайт партнера за наданими інструкціями;</li>' +
              '</ul>' +
              '<span style="color:red">⚡ Компанія ТОВ “Сучасний факторинг” не стягує комісію за здійснення платежу.</span> <br>' +
              '<span style="color:red">! Важливо: Платіж зараховується протягом кількох днів.</span>',
        },
        {
          id: 'faq-009',
          q_text: 'Чи можна погасити кредит достроково?',
          category_id: 4,
          q_answer:
            'Так, усі клієнти можуть погасити кредит або позику раніше встановленого строку.<br><br>' +
            '<strong>При достроковому погашенні:</strong><br>' +
            '<ul>' +
            '<li>Відсотки нараховуються тільки за фактичний період користування коштами.</li>' +
            '</ul>' +
            'Для розрахунку точної суми погашення:<br>' +
            '<ul>' +
            '<li>Перевірте суму в особистому кабінеті у вкладці «Сума для повного погашення»;</li>' +
            '<li>Або зверніться до контакт-центру: <strong><a href="tel:+380445936633">044-593-66-33</a></strong>;</li>' +
            '</ul>',
        },
        {
          id: 'faq-010',
          q_text: 'Що означає довгострокове погашення?',
          category_id: 4,
          q_answer:
            'Це повне погашення залишку одним платежем в один день.<br><br>' +
            'Після зарахування оплати кредитний договір буде закритий.<br><br>' +
            'Обов\'язково переконайтеся, що ви сплатили саме повну суму (з урахуванням відсотків на день оплати).<br><br>' +
            '<span style="color:red">⚡ Рекомендуємо уточнювати суму повного погашення в день внесення платежу, щоб уникнути недоплат.</span>',
        },
        {
          id: 'faq-011',
          q_text: 'Як закрити кредит?',
          category_id: 4,
          q_answer:
            'Кредит закривається автоматично після повної оплати залишку за договором. Для закриття потрібно:<br><br>' +
            '<strong>1. Дізнатися актуальну суму повного погашення:</strong><br>' +
            '<ul>' +
            '<li>В особистому кабінеті у вкладці «Сума для повного погашення»;</li>' +
            '<li>Або за телефоном контакт-центру: <strong><a href="tel:+380445936633">044-593-66-33</a></strong>;</li>' +
            '</ul>' +
            '<strong>2. Сплатити всю суму одним платежем.</strong><br><br>' +
            '<strong>3. Після зарахування коштів:</strong><br>' +
            '<ul>' +
            '<li>Перевірити статус договору в особистому кабінеті (статус зміниться на "Закритий");</li>' +
            '<li>Або уточнити інформацію телефоном.</li>' +
            '</ul>' +
            '<span style="color:red">⚡ Зверніть увагу: статус оновлюється після надходження коштів і обробки платежу.</span>',
        },
        {
          id: 'faq-012',
          q_text: 'Що робити у разі неможливості своєчасно сплатити кредит і які наслідки прострочки?',
          category_id: 5,
          q_answer:
            'Якщо ви не можете вчасно сплатити кредит або виникла прострочка, рекомендуємо:<br><br>' +
            '<strong>1. Негайно звернутися до відділу врегулювання простроченої заборгованості:</strong><br>' +
            '<ul>' +
            '<li>Телефон: <strong><a href="tel:+380443550920">044-355-09-20</a></strong></li>' +
            '<li>Графік роботи: Понеділок–п’ятниця: 09:00–19:00; Вихідні: субота, неділя та святкові дні.</li>' +
            '</ul>' +
            '<strong>2. Що буде, якщо не сплачувати кредит вчасно:</strong><br>' +
            '<ul>' +
            '<li>Нарахування пені та штрафних санкцій;</li>' +
            '<li>Збільшення суми заборгованості;</li>' +
            '<li>Погіршення кредитної історії;</li>' +
            '<li>Передача інформації до бюро кредитних історій;</li>' +
            '<li>Можливість примусового стягнення боргу через суд.</li>' +
            '</ul>' +
            '<strong>3. Додаткова інформація:</strong><br>' +
            'Усі умови щодо прострочення платежів і можливих наслідків прописані в пункті 2.9 кредитного договору.<br>' +
            '<span style="color:red">⚡ Рекомендуємо обов’язково ознайомитися з цим пунктом для повного розуміння своїх прав і обов’язків.</span>',
        },
        {
          id: 'faq-013',
          q_text: 'Чому після сплати залишок у кабінеті не змінюється відразу?',
          category_id: 5,
          q_answer:
            'Після оплати ваш платіж спочатку відображається на авансовому рахунку. Це означає:<br>' +
            '<ul>' +
            '<li>Кошти зареєстровані системою;</li>' +
            '<li>Вони будуть автоматично списані на погашення тіла кредиту у день найближчого планового платежу (розрахункова дата за графіком);</li>' +
            '</ul>' +
            '<strong>Що важливо знати:</strong><br>' +
            '<ul>' +
            '<li>Залишок зменшується після настання планової дати платежу;</li>' +
            '<li>Інформація в особистому кабінеті оновлюється раз на добу;</li>' +
            '</ul>' +
            '<span style="color:red">⚡ Ваш платіж не загубився — він зафіксований і обов’язково буде врахований у найближчому розрахунку.</span>',
        },
        {
          id: 'faq-014',
          q_text: 'Як повернути або перерахувати помилково сплачені кошти?',
          category_id: 6,
          q_answer:
            'Якщо ви здійснили помилкову оплату або надлишковий платіж, дійте так:<br><br>' +
            '<strong>1. Зателефонуйте в службу підтримки:</strong><br>' +
            '<ul><li><strong><a href="tel:+380445936633">044-593-66-33</a></strong> — ми надішлемо вам шаблон заяви.</li></ul>' +
            '<strong>2. Або надішліть лист на електронну пошту:</strong><br>' +
            '<ul><li><strong><a href="mailto:info@sfactor.com.ua">info@sfactor.com.ua</a></strong> — вкажіть проблему і додайте квитанцію про оплату.</li></ul>' +
            '<strong>3. Заповніть заяву:</strong><br>' +
            '<ul>' +
            '<li>Для повернення коштів на банківський рахунок;</li>' +
            '<li>Або для зарахування коштів на діючий кредитний договір.</li>' +
            '</ul>' +
            '<strong>4. Очікуйте обробку звернення:</strong><br>' +
            '<ul><li>Термін розгляду запиту — до 14 календарних днів з моменту отримання повного пакета документів.</li></ul>' +
            '<span style="color:red">⚡ Без наданої заяви компанія не може обробити Ваше звернення.</span>',
        },
        {
          id: 'faq-015',
          q_text: 'Як замовити довідку про закриття кредитного договору?',
          category_id: 7,
          q_answer:
            'Ви можете замовити довідку про закриття договору будь-яким зручним способом:<br>' +
            '<strong>1. Через електронну пошту:</strong><br>' +
            '<ul>' +
            '<li>Надішліть листа на адресу: <strong><a href="mailto:info@sfactor.com.ua">info@sfactor.com.ua</a></strong>.</li>' +
            '<li>Обов’язково вкажіть:<br>' +
            '— Ваші ПІБ;<br>' +
            '— Номер кредитного договору;<br>' +
            '— Контактний номер телефону;<br>' +
            '— Електронну адресу для отримання довідки.</li>' +
            '</ul>' +
            '<strong>2. Телефоном:</strong><br>' +
            '<ul>' +
            '<li>Зателефонуйте в службу підтримки: <strong><a href="tel:+380445936633">044-593-66-33</a></strong>.</li>' +
            '<li>Наш консультант допоможе вам оформити замовлення.</li>' +
            '</ul>' +
            '<br><strong>Важлива інформація:</strong><br>' +
            '<ul>' +
            '<li><span style="color:red">Довідка видається безкоштовно.</span></li>' +
            '<li><span style="color:red">Довідка надсилається на електронну адресу, вказану клієнтом.</span></li>' +
            '<li><span style="color:red">Термін виготовлення довідки — від 14 до 30 робочих днів з моменту подання запиту.</span></li>' +
            '<li><span style="color:red">⚡ Рекомендуємо уважно перевіряти правильність вказаної електронної адреси для отримання довідки.</span></li>' +
            '</ul>'
        }
      ],
    }
  }
}
</script>
<style lang="scss" scoped>

// .faq-category refactor: h2 moved to .question_block_container, padding-left replaced, max-width removed
.faq-category {
  width: 100%;
  margin-bottom: 30px;

  .question_block_container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 700px;
    width: 100%;

    h2 {
      font-family: 'Montserrat', sans-serif;
      font-weight: 600;
      font-size: 20px;
      margin: 30px 0 10px;
      color: #000;
      text-align: start;
      width: 100%;
    }
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
{
  opacity: 0;
}

.frequent_questions-container {
  display: flex;
  max-width: 1400px;
  width: 98%;
  margin-top: 50px;
  justify-content: space-between;

  .question_blockWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .question_block {
    font-size: 25px;
    font-weight: 500;
    font-family: 'Montserrat';
    color: #000;
    min-height: 100px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    gap: 20px;
    cursor: pointer;
  }

  .question_text {
    display: flex;
    flex-direction: column;
    justify-content: center;
    font-family: 'Montserrat';
    font-weight: 500;
    font-size: 25px;
    color: #000;
  }

  .icon_wrapper {
    padding: 2px;
    height: 30px;
    width: 30px;
    border-radius: 50%;
    position: relative;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .closeIcon {
    font-size: 20px;
    font-weight: 600;
    transition: transform 0.3s;
  }

  .rotated {
    transform: rotate(180deg);
  }

  .question_block:hover .icon_wrapper {
    background-color: #12b423;
    color: white;
  }

  .answer {
    width: 100%;
    font-family: 'Montserrat', Arial, sans-serif;
    font-weight: 300;
    color: #000;
    font-size: 14px;
    line-height: 1.55;
  }
}

.bold_title {
  color: #000;
  font-size: 45px;
  font-family: 'Montserrat', Arial, sans-serif;
  line-height: 1.55;
  font-weight: 700;
  background-position: center center;
  margin-bottom: 80px;
}

@media (max-width: 720px) {
  .frequent_questions-container {
    flex-direction: column;
    align-items: center;
  }
}

@media (max-width: 500px) {

  .frequent_questions-container {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .question_block {
      max-width: 100%;
    }
    .question_text {
      font-size: 18px;
    }
    .bold_title {
      font-size: 40px;
      text-align: center;
    }
  }
}
</style>
